import axios from "axios";

const TOKEN = process.env.REACT_APP_TOKEN;

const instance = axios.create({
  // baseURL: 'http://new-okapi.ddev.site/',
  // auth: {
  //   username: 'Pedro',
  //   password: 'Testing123'
  // }
  baseURL: 'http://www.okapimadrededia.es/',
  headers: {'Authorization': 'Bearer '+ TOKEN}
});

export default instance;